/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileReference,
    MediaFileReferenceFromJSON,
    MediaFileReferenceFromJSONTyped,
    MediaFileReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileTemplatePartialUpdate
 */
export interface MediaFileTemplatePartialUpdate {
    /**
     * 
     * @type {MediaFileReference}
     * @memberof MediaFileTemplatePartialUpdate
     */
    file?: MediaFileReference;
    /**
     * 
     * @type {string}
     * @memberof MediaFileTemplatePartialUpdate
     */
    name?: string;
}

export function MediaFileTemplatePartialUpdateFromJSON(json: any): MediaFileTemplatePartialUpdate {
    return MediaFileTemplatePartialUpdateFromJSONTyped(json, false);
}

export function MediaFileTemplatePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileTemplatePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : MediaFileReferenceFromJSON(json['file']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MediaFileTemplatePartialUpdateToJSON(value?: MediaFileTemplatePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': MediaFileReferenceToJSON(value.file),
        'name': value.name,
    };
}


